import React, { useContext } from "react";

//importing components from react-bootstrap
import {
  OverlayTrigger,
  Popover,
  Accordion,
  Alert,
  Button,
  Stack,
} from "react-bootstrap";

//importing icons from react-icons
import { BsBookmarkPlus, BsBookmarkStarFill } from "react-icons/bs";

//import exams data
import exams from "../data/exams.json";

const Card = (props) => {
  //checking if I have data for this exam and saving them
  let people = 0;
  let score = 0;
  exams.map((item, i) => {
    if (item.name === props.date) {
      people = item.people;
      score = item.score;
    }
  });

  return (
    <div>
      <Alert
        variant="light"
        style={
          props.variant
            ? { border: "2px solid black" }
            : { border: "1px solid gray" }
        }
      >
        <Alert.Heading>
          <Stack direction="horizontal">
            <div>
              {/* showing exam date */ props.date}
              {people ? (
                <OverlayTrigger
                  trigger="hover"
                  placement="right"
                  overlay={
                    <Popover>
                      <Popover.Body style={{ fontSize: "12px" }}>
                        <p>
                          <strong>{people}</strong> students attended this exam.{" "}
                          <br />
                          Avarage score was: <strong>{score}</strong>
                        </p>
                        <p style={{ color: "#bfbfbf", marginBottom: "0px" }}>
                          Value in the exam: {props.value}
                        </p>
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <div 
                    className="mt-1"
                    style={{
                      fontSize:"12px", 
                      fontWeight:"normal"
                    }}
                  >
                    info on this exam
                  </div>
                </OverlayTrigger>
              ) : (
                <div 
                  className="mt-1"
                  style={{
                    fontSize:"12px", 
                    fontWeight:"normal",
                    color: "#bfbfbf"
                  }}
                >
                  no info
                </div>
              )}
            </div>
            <div className="ms-auto">
              {props.topic ? (
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="me-2"
                  style={{ fontSize: "14px" }}
                >
                  <span className="my-1">{props.topic}</span>
                </Button>
              ) : (
                ""
              )}
              {props.saved ? (
                <>
                  <BsBookmarkStarFill
                    size="2rem"
                    className="d-none d-md-inline me-2"
                    onClick={() => {
                      props.removeSave(props.saveid);
                    }}
                  />
                  <p
                    className="d-block d-md-none ms-1 mt-1"
                    style={{fontSize:"12px", fontWeight:"normal"}}
                    onClick={() => {
                      props.removeSave(props.saveid);
                    }}
                  >
                    remove from saved
                  </p>
                </>
              ) : (
                <>
                  <BsBookmarkPlus
                    size="2rem"
                    className="d-none d-md-inline me-2"
                    onClick={() => {
                      props.addSave(props.saveid);
                    }}
                  />
                  <p
                    className="d-block d-md-none ms-3 mt-1"
                    style={{fontSize:"12px", fontWeight:"normal"}}
                    onClick={() => {
                      props.addSave(props.saveid);
                    }}
                  >
                    save for later
                  </p>
                </>
              )}
            </div>
          </Stack>
        </Alert.Heading>
        <p>
          {props.question}
          {props.textmedia ? (
            <img
              src={process.env.PUBLIC_URL + `/media/${props.textmedia}`}
              style={{ width: "100%" }}
            />
          ) : (
            ""
          )}
        </p>
        <hr />
        {props.answer ? (
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>See the answer</Accordion.Header>
              <Accordion.Body>
                {props.answer}
                {props.answermedia ? (
                  <img
                    src={process.env.PUBLIC_URL + `/media/${props.answermedia}`}
                    style={{ width: "100%" }}
                  />
                ) : (
                  ""
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <div>
            <a
              href={`mailto:site.tech.support@protonmail.com?subject=Appello del ${props.date}&body=For the following question: ${props.question} I suggest this answer:`}
              target="_blank"
              rel="noreferrer"
            >
              <Button variant="outline-dark" size="sm" className="">
                Suggest an answer
              </Button>
            </a>
            <i className="ms-3">no answer avaiable</i>
          </div>
        )}
      </Alert>
    </div>
  );
};

export default Card;
